import { createApp } from 'vue'
import { createPinia } from 'pinia'
import i18next from 'i18next'
import App from './App.vue'
import router from './router'
import i18nPlugin from './i18n-plugin'
import './styles/main.css'
import translations from './locales'
import { useAuthStore } from './stores/authStore'

// Initialize i18next
const savedLanguage = localStorage.getItem('language') || 'fr'
i18next.init({
  lng: savedLanguage,
  fallbackLng: 'fr',
  resources: translations,
})

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(router)
app.use(i18nPlugin)

// Initialize auth store with localStorage
const authStore = useAuthStore()
authStore.initializeFromStorage()

app.mount('#app')
